/* Keep Card — Custom JS — build 2026-05-21-v6 */
(function () {
  function kcLocalUrl(p){var r=(window.kcRoot||'/');return (r==='/'?'':r)+p;}
  'use strict';

  /* Refcounted body scroll lock. Several overlays (cart, menu, auth, search,
     quick-view, lightbox, filter drawer, video) can be open at the same time;
     the body only unlocks when the LAST one closes. Fixes "page scrolls behind
     the menu after closing the cart" and "body stuck locked". */
  var ScrollLock = {
    _held: {},
    acquire: function (key) {
      var was = Object.keys(this._held).length;
      this._held[key] = true;
      if (was === 0) {
        document.body.classList.add('kc-no-scroll', 'kc-lock-scroll');
        document.body.style.overflow = 'hidden';
      }
    },
    release: function (key) {
      delete this._held[key];
      if (Object.keys(this._held).length === 0) {
        document.body.classList.remove('kc-no-scroll', 'kc-lock-scroll');
        document.body.style.overflow = '';
      }
    },
    releaseAll: function () { this._held = {}; this.release('__all'); }
  };

  /* Element scope for section-local initialisers. Normally `document`; during a
     Theme Editor `shopify:section:load` it is the reloaded section root so only
     that section's fresh DOM gets (re)bound. */
  var SCOPE = document;

  /* Inline, accessible error next to a form's submit button. */
  function showFormError(form, msg) {
    if (!form) return;
    var el = form.querySelector('.kc-form-error');
    if (!el) {
      el = document.createElement('div');
      el.className = 'kc-form-error';
      el.setAttribute('role', 'alert');
      var btn = form.querySelector('[type="submit"], .kc-btn-add');
      (btn && btn.parentNode ? btn.parentNode : form).appendChild(el);
    }
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.hidden = true; }, 6000);
  }

  /* ──────────────────────────
     3D CARD TILT + FLIP
  ────────────────────────── */
  function initCard() {
    /* Scope to the HERO card specifically — there are other .kc-card-stage
       instances on the page (bento, tracking-features) which would
       otherwise hijack the global querySelector and steal click events. */
    var card  = SCOPE.querySelector('[data-kc-card]');
    if (!card) return;
    var stage = card.closest('.kc-card-stage');
    if (!stage) return;
    var inner = card.querySelector('.kc-card-3d');     /* tilt layer */
    if (!inner) return;

    var faces    = card.querySelectorAll('.kc-face');
    var flipped  = false;
    var hovering = false;
    var autoSpin = true;
    var tilt     = { x: -6, y: 12 };          /* matches design's initial rest */
    var light    = { x: 0.7, y: 0.2 };
    var raf      = null;
    var t0       = performance.now();

    function apply() {
      /* Tilt is set on the INNER 3D layer; flip is handled by the
         .kc-flipped class on the wrap (pure CSS, can't be broken by a
         throttled JS loop). The two transforms compose because the wrap
         and inner both have transform-style: preserve-3d.

         NOTE: do NOT set a `filter:` on .kc-card-wrap — WebKit (iOS Safari
         + Chrome under filter) ignores backface-visibility:hidden when the
         element has a filter applied, which causes the FRONT face to bleed
         through mirrored on the back of the card. The static drop-shadow
         lives on .has-shadow in CSS (lower-impact than a dynamic one). */
      inner.style.transform = 'rotateX(' + tilt.x + 'deg) rotateY(' + tilt.y + 'deg)';
      faces.forEach(function (f) {
        f.style.setProperty('--lx', light.x);
        f.style.setProperty('--ly', light.y);
      });
    }

    function setFlipped(v) {
      flipped = v;
      card.classList.toggle('kc-flipped', flipped);
    }

    /* Auto-spin loop (matches design exactly) */
    function loop(t) {
      if (!running) return;                               /* paused: off-screen or hidden tab */
      var dt = (t - t0) / 1000;
      if (autoSpin && !hovering) {
        tilt.x  = Math.sin(dt * 0.8) * 8 - 3;
        tilt.y  = Math.sin(dt * 0.5) * 40;
        light.x = 0.5 + Math.cos(dt * 0.5) * 0.4;
        light.y = 0.3 + Math.sin(dt * 0.8) * 0.25;
        apply();
      }
      raf = requestAnimationFrame(loop);
    }

    /* Hover-tilt — only on devices that actually hover (desktop / pen).
       Without this guard, iOS Safari fires a synthetic mousemove after every
       touch, which sets hovering=true forever and freezes the auto-spin. */
    var hoverCapable = !!(window.matchMedia && window.matchMedia('(hover: hover)').matches);
    if (hoverCapable) {
      stage.addEventListener('mousemove', function (e) {
        hovering = true;
        var r  = stage.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;
        var py = (e.clientY - r.top)  / r.height;
        tilt.x  = (0.5 - py) * 18;
        tilt.y  = (px - 0.5) * 28;
        light.x = 1 - px;
        light.y = 1 - py;
        apply();
      });
      stage.addEventListener('mouseenter', function () { hovering = true; });
      stage.addEventListener('mouseleave', function () { hovering = false; });
    }

    /* Flip via click. CSS touch-action:manipulation on .kc-card-stage
       removes the iOS 300ms delay, so click feels instant on touch too —
       no separate touchend handler needed (which was double-flipping). */
    stage.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-kc-swatch]')) return;
      setFlipped(!flipped);
    });

    /* Keyboard flip */
    stage.setAttribute('tabindex', '0');
    stage.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        setFlipped(!flipped);
      }
    });

    /* Skip auto-spin on prefers-reduced-motion (still allow manual tilt) */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      autoSpin = false;
    }

    apply();

    /* Run the auto-spin only while the card is actually on screen and the tab
       is visible. Previously the rAF loop ran at 60fps for the whole session,
       even scrolled far below the fold — wasted main-thread time on mobile. */
    var running = false, pausedAt = 0, stageVisible = true;
    function startLoop() {
      if (running || !autoSpin) return;
      running = true;
      if (pausedAt) { t0 += (performance.now() - pausedAt); pausedAt = 0; }   /* keep the motion continuous */
      raf = requestAnimationFrame(loop);
    }
    function stopLoop() {
      if (!running) return;
      running = false; pausedAt = performance.now();
      cancelAnimationFrame(raf);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { stageVisible = en.isIntersecting; if (stageVisible && !document.hidden) startLoop(); else stopLoop(); });
      }, { threshold: 0.05 }).observe(stage);
    } else { startLoop(); }
    if (!window.__kcCardVis) {
      window.__kcCardVis = true;
      document.addEventListener('visibilitychange', function () { if (document.hidden) stopLoop(); else if (stageVisible) startLoop(); });
    }
  }

  /* Reviews section — distribution bars + helpful pills + sort + show more */
  function initReviews() {
    var section = SCOPE.querySelector('.kc-rev');
    if (!section) return;

    /* Distribution bars: animate width on scroll-in */
    var bars = section.querySelectorAll('[data-kc-bar]');
    bars.forEach(function (b) { b.style.width = '0%'; });
    if ('IntersectionObserver' in window && bars.length) {
      var barIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var pct = parseFloat(e.target.getAttribute('data-kc-bar')) || 0;
            e.target.style.width = pct + '%';
            barIO.unobserve(e.target);
          }
        });
      }, { threshold: 0.5 });
      bars.forEach(function (b) { barIO.observe(b); });
    } else {
      bars.forEach(function (b) {
        var pct = parseFloat(b.getAttribute('data-kc-bar')) || 0;
        b.style.width = pct + '%';
      });
    }

    /* Helpful pills (only one of Yes/No active per review) */
    section.querySelectorAll('.kc-rev-item').forEach(function (item) {
      var pills = item.querySelectorAll('[data-kc-helpful]');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.classList.contains('is-on')) {
            pill.classList.remove('is-on');
            return;
          }
          pills.forEach(function (p) { p.classList.remove('is-on'); });
          pill.classList.add('is-on');
        });
      });
    });

    /* Show more: reveal hidden reviews in batches of 12 */
    var moreBtn = section.querySelector('[data-kc-rev-more]');
    var list    = section.querySelector('[data-kc-rev-list]');
    var countEl = section.querySelector('[data-kc-rev-count]');
    if (moreBtn && list) {
      var hidden = list.querySelectorAll('[data-kc-rev-card][hidden]');
      if (!hidden.length) { moreBtn.hidden = true; }
      moreBtn.addEventListener('click', function () {
        var remaining = list.querySelectorAll('[data-kc-rev-card][hidden]');
        var batch = 12;
        for (var i = 0; i < Math.min(batch, remaining.length); i++) {
          remaining[i].removeAttribute('hidden');
        }
        var stillHidden = list.querySelectorAll('[data-kc-rev-card][hidden]').length;
        var visible = list.querySelectorAll('.kc-rev-item').length - stillHidden;
        if (countEl) {
          var total = list.querySelectorAll('.kc-rev-item').length;
          countEl.textContent = '1–' + visible + ' of ' + total + ' Reviews';
        }
        if (stillHidden === 0) moreBtn.hidden = true;
      });
    }

    /* Sort dropdown */
    var sort = section.querySelector('[data-kc-rev-sort]');
    if (sort && list) {
      sort.addEventListener('change', function () {
        /* Sort is decorative — items are pre-ordered most-recent in source.
           Wire to a reviews app metafield later if needed. */
        list.style.opacity = '0.4';
        setTimeout(function () { list.style.opacity = ''; }, 220);
      });
    }
  }
  /* Back-compat shim for the old name */
  function initRevShowMore() { initReviews(); }

  /* Product page v2 — bundle radios, use-case tabs, buy-now redirect. */
  function initPpV2() {
    var pp = SCOPE.querySelector('[data-kc-pp]');
    if (!pp) return;

    /* Bundle selector */
    var bundles = pp.querySelectorAll('[data-kc-bundle]');
    var variantInput = pp.querySelector('[data-kc-variant-id]');
    var atcPrice = pp.querySelector('[data-kc-atc-price]');
    var atcText = pp.querySelector('[data-kc-atc-text]');
    var priceMain = pp.querySelector('[data-kc-price]');
    bundles.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        bundles.forEach(function (c) { c.classList.remove('kc-active'); });
        card.classList.add('kc-active');
        var radio = card.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        var vid = card.getAttribute('data-variant-id');
        var money = card.getAttribute('data-money');
        var atc = card.getAttribute('data-atc-text');
        if (variantInput && vid) variantInput.value = vid;
        if (atcPrice && money) atcPrice.textContent = money;
        if (priceMain && money) priceMain.textContent = money;
        if (atcText && atc) atcText.textContent = atc;
      });
    });

    /* Use-case tabs */
    var ucTabs = pp.querySelectorAll('[data-kc-uc-tab]');
    var ucPanels = pp.querySelectorAll('[data-kc-uc-panel]');
    ucTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-kc-uc-tab');
        ucTabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('kc-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        ucPanels.forEach(function (p) {
          p.classList.toggle('kc-active', p.getAttribute('data-kc-uc-panel') === key);
        });
      });
    });

    /* Buy Now — fast-add to cart then redirect to checkout */
    var buyNow = pp.querySelector('[data-kc-buy-now]');
    var form = pp.querySelector('.kc-pp-buy-form');
    if (buyNow && form) {
      buyNow.addEventListener('click', function () {
        buyNow.disabled = true;
        var origText = buyNow.innerHTML;
        buyNow.innerHTML = (window.kcStrings && window.kcStrings.redirecting) || 'Redirecting…';
        var fd = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: fd })
          .then(function (r) {
            if (!r.ok) { return r.json().catch(function(){return {};}).then(function(){ throw new Error('add failed'); }); }
            window.location.href = '/checkout';
          })
          .catch(function () {
            buyNow.disabled = false;
            buyNow.innerHTML = origText;
          });
      });
    }
  }

  /* Article share — copy current page URL to clipboard with a flash. */
  function initArticleCopyLink() {
    var btn = SCOPE.querySelector('[data-kc-copy-link]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var url = window.location.href;
      var done = function () {
        btn.classList.add('kc-copied');
        var prevLabel = btn.getAttribute('aria-label');
        btn.setAttribute('aria-label', (window.kcStrings && window.kcStrings.linkCopied) || 'Link copied');
        setTimeout(function () {
          btn.classList.remove('kc-copied');
          if (prevLabel) btn.setAttribute('aria-label', prevLabel);
        }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(function () {});
      } else {
        var ta = document.createElement('textarea');
        ta.value = url; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        document.body.removeChild(ta);
      }
    });
  }

  /* Finish swatches — wired separately so they work on touch devices too
     (initCard above is hover-gated and skipped on phones). */
  function initCardSwatches() {
    var card = SCOPE.querySelector('[data-kc-card]');
    if (!card) return;
    var swatches = SCOPE.querySelectorAll('[data-kc-swatch]');
    if (!swatches.length) return;
    function handle(e, btn) {
      e.preventDefault();
      e.stopPropagation();
      var mat = btn.getAttribute('data-kc-swatch');
      if (!mat) return;
      card.className = card.className
        .replace(/\bkc-mat(-\w+)?\b/g, '')
        .replace(/\s+/g, ' ')
        .trim() + ' kc-mat-' + mat;
      swatches.forEach(function (s) {
        var on = s === btn;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }
    swatches.forEach(function (btn) {
      btn.addEventListener('click',    function (e) { handle(e, btn); });
      btn.addEventListener('touchend', function (e) { handle(e, btn); }, { passive: false });
    });
  }

  /* ══════════════════════════
     WISHLIST — localStorage-backed, no app required
  ══════════════════════════ */
  var Wishlist = {
    KEY: 'kc_wishlist_v1',

    read: function () {
      try { return JSON.parse(localStorage.getItem(this.KEY) || '[]'); } catch (e) { return []; }
    },
    write: function (arr) {
      try { localStorage.setItem(this.KEY, JSON.stringify(arr)); } catch (e) {}
    },
    has: function (handle) {
      return this.read().some(function (item) { return item.handle === handle; });
    },
    add: function (item) {
      var arr = this.read();
      if (this.has(item.handle)) return arr;
      arr.unshift(item);
      arr = arr.slice(0, 50);
      this.write(arr);
      this.dispatch();
      return arr;
    },
    remove: function (handle) {
      var arr = this.read().filter(function (item) { return item.handle !== handle; });
      this.write(arr);
      this.dispatch();
      return arr;
    },
    toggle: function (item) {
      return this.has(item.handle) ? this.remove(item.handle) : this.add(item);
    },
    dispatch: function () {
      document.dispatchEvent(new CustomEvent('kc:wishlist-change', { detail: { count: this.read().length } }));
    },

    init: function () {
      var self = this;

      /* Mark all wishlist buttons with current state */
      this.syncButtons();

      /* Click handler */
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-kc-wl-toggle]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();

        var item = {
          handle: btn.dataset.kcWlHandle,
          title:  btn.dataset.kcWlTitle,
          image:  btn.dataset.kcWlImage,
          price:  btn.dataset.kcWlPrice,
          url:    btn.dataset.kcWlUrl
        };
        self.toggle(item);
        if (navigator.vibrate) navigator.vibrate(10);
      });

      /* Re-sync UI on storage change */
      document.addEventListener('kc:wishlist-change', function () { self.syncButtons(); self.updateCount(); });
      window.addEventListener('storage', function (e) {
        if (e.key === self.KEY) { self.syncButtons(); self.updateCount(); self.renderPage(); }
      });

      this.updateCount();
      this.renderPage();
    },

    syncButtons: function () {
      var self = this;
      document.querySelectorAll('[data-kc-wl-toggle]').forEach(function (btn) {
        var on = self.has(btn.dataset.kcWlHandle);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.setAttribute('aria-label', on ? ((window.kcStrings && window.kcStrings.wishlistRemove) || 'Remove from wishlist') : ((window.kcStrings && window.kcStrings.wishlistAdd) || 'Add to wishlist'));
        var svg = btn.querySelector('svg');
        if (svg) svg.setAttribute('fill', on ? 'currentColor' : 'none');
      });
    },

    updateCount: function () {
      var n = this.read().length;
      document.querySelectorAll('[data-kc-wl-count]').forEach(function (el) {
        el.textContent = n;
        if (n > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
    },

    renderPage: function () {
      var grid = document.querySelector('[data-kc-wl-grid]');
      if (!grid) return;
      var empty = document.querySelector('[data-kc-wl-empty]');
      var countEl = document.querySelector('[data-kc-wl-page-count]');
      var arr = this.read();

      if (countEl) countEl.textContent = arr.length === 0 ? ((window.kcStrings && window.kcStrings.noItems) || 'No items yet') : (((window.kcStrings && window.kcStrings.itemsSaved) || '[count] items saved').replace('[count]', arr.length));
      if (empty) empty.hidden = arr.length > 0;

      grid.innerHTML = arr.map(function (item) {
        return '<a href="' + item.url + '" class="kc-pc">' +
                 '<div class="kc-pc-media">' +
                   '<img class="kc-pc-img kc-pc-img-1" src="' + item.image + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' +
                   '<button type="button" class="kc-wl-btn kc-wl-btn--sm" data-kc-wl-toggle' +
                   ' data-kc-wl-handle="' + item.handle + '" data-kc-wl-title="' + (item.title || '').replace(/"/g, '&quot;') + '"' +
                   ' data-kc-wl-image="' + item.image + '" data-kc-wl-price="' + item.price + '"' +
                   ' data-kc-wl-url="' + item.url + '" aria-pressed="true" aria-label="' + ((window.kcStrings && window.kcStrings.wishlistRemove) || 'Remove from wishlist') + '">' +
                     '<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.8"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
                   '</button>' +
                 '</div>' +
                 '<div class="kc-pc-body">' +
                   '<div class="kc-pc-title">' + item.title + '</div>' +
                   '<div class="kc-pc-price-row"><span class="kc-pc-price">' + item.price + '</span></div>' +
                 '</div>' +
               '</a>';
      }).join('');
    }
  };

  /* ══════════════════════════
     RECENTLY VIEWED — render strip from localStorage
  ══════════════════════════ */
  function renderRecentlyViewed() {
    var section = SCOPE.querySelector('[data-kc-rv]');
    var grid = SCOPE.querySelector('[data-kc-rv-grid]');
    if (!section || !grid) return;

    var stored;
    try { stored = JSON.parse(localStorage.getItem('kc_recently_viewed_v2') || '[]'); }
    catch (e) { return; }

    /* Don't show on the page user is currently viewing */
    var current = window.location.pathname;
    var items = stored.filter(function (i) { return i.url !== current; });

    if (items.length < 2) return; /* don't bother showing 1 item */

    items = items.slice(0, 4);
    grid.innerHTML = items.map(function (item) {
      return '<a href="' + item.url + '" class="kc-pc">' +
               '<div class="kc-pc-media">' +
                 (item.image ? '<img class="kc-pc-img kc-pc-img-1" src="' + item.image + '" alt="" loading="lazy">' : '') +
               '</div>' +
               '<div class="kc-pc-body">' +
                 '<div class="kc-pc-title">' + item.title + '</div>' +
                 '<div class="kc-pc-price-row"><span class="kc-pc-price">' + item.price + '</span></div>' +
               '</div>' +
             '</a>';
    }).join('');
    section.hidden = false;
  }

  /* Track current product page */
  function trackProductView() {
    var page = SCOPE.querySelector('.kc-pp');
    if (!page) return;

    var titleEl = page.querySelector('.kc-pp-title');
    var imgEl   = page.querySelector('#kc-pp-img');
    var priceEl = page.querySelector('[data-kc-price]');
    if (!titleEl) return;

    var item = {
      url: window.location.pathname,
      title: titleEl.textContent.trim(),
      image: imgEl ? imgEl.src : '',
      price: priceEl ? priceEl.textContent.trim() : ''
    };

    try {
      var key = 'kc_recently_viewed_v2';
      var arr = JSON.parse(localStorage.getItem(key) || '[]');
      arr = arr.filter(function (i) { return i.url !== item.url; });
      arr.unshift(item);
      arr = arr.slice(0, 8);
      localStorage.setItem(key, JSON.stringify(arr));
    } catch (e) {}
  }

  /* ══════════════════════════
     PRODUCT TABS — sticky, click to switch
  ══════════════════════════ */
  function initProductTabs() {
    var tabs = SCOPE.querySelectorAll('.kc-tab');
    var panels = SCOPE.querySelectorAll('.kc-tab-panel');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var name = this.getAttribute('data-kc-tab');
        tabs.forEach(function (t) {
          t.classList.toggle('kc-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('kc-active', p.getAttribute('data-kc-panel') === name);
        });
      });
    });
  }

  /* ──────────────────────────
     OVERVIEW STACKED CARDS — each .kc-ov-block is position:sticky with
     progressive top (--ov-i). On scroll, cards being covered by the
     next card scale + dim slightly, producing the "deck of cards"
     effect. Respects prefers-reduced-motion via CSS (static layout).
  ────────────────────────── */
  function initOverviewReveal() {
    if (window.__kcOvBound) return;                      /* global listeners: bind once */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.__kcOvBound = true;
    var raf = null;
    function update() {
      raf = null;
      var blocks = document.querySelectorAll('.kc-ov-block');   /* re-query: survives section reloads */
      for (var i = 0; i < blocks.length; i++) {
        var block = blocks[i], next = blocks[i + 1];
        block.style.setProperty('--ov-i', i);
        var rect = block.getBoundingClientRect(), coverage = 0;
        if (next) {
          var overlap = rect.bottom - next.getBoundingClientRect().top;
          coverage = Math.max(0, Math.min(1, overlap / Math.max(1, rect.height)));
        }
        block.style.transform = 'scale(' + (1 - coverage * 0.06).toFixed(3) + ')';
        block.style.opacity = (1 - coverage * 0.35).toFixed(3);
      }
    }
    function onScroll() { if (raf == null) raf = requestAnimationFrame(update); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-kc-tab="overview"]')) setTimeout(onScroll, 50); });
    update();
  }

  /* ──────────────────────────
     TRACKING-FEATURES ACCORDION + secondary 3D card
  ────────────────────────── */
  function initTrackingFeatures() {
    /* Accordion */
    SCOPE.querySelectorAll('.kc-tf-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = this.closest('.kc-tf-item');
        var isOpen = item.classList.contains('kc-open');
        /* close all */
        SCOPE.querySelectorAll('.kc-tf-item.kc-open').forEach(function (el) {
          el.classList.remove('kc-open');
          var q = el.querySelector('.kc-tf-q');
          if (q) q.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('kc-open');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* Secondary 3D card tilt — only on hover-capable devices */
    var stage = SCOPE.querySelector('.kc-tf-stage');
    var card  = SCOPE.querySelector('[data-kc-card-tf]');
    if (!stage || !card) return;
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var flipped = false;
    var tilt = { x: 0, y: 0 };
    var REST = { x: -6, y: 12 };
    var raf = null;
    function apply() {
      var ry = tilt.y + (flipped ? 180 : 0);
      card.style.transform = 'rotateX(' + tilt.x + 'deg) rotateY(' + ry + 'deg)';
    }
    stage.addEventListener('mousemove', function (e) {
      var r  = stage.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width;
      var py = (e.clientY - r.top)  / r.height;
      tilt.y = (px - 0.5) * 24;
      tilt.x = (0.5 - py) * 14;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(apply);
    });
    stage.addEventListener('mouseleave', function () {
      tilt.x = REST.x; tilt.y = REST.y;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(apply);
    });
    stage.addEventListener('click', function () { flipped = !flipped; apply(); });
    tilt.x = REST.x; tilt.y = REST.y;
    apply();
  }

  /* ──────────────────────────
     FAQ ACCORDION
  ────────────────────────── */
  function initFaq() {
    SCOPE.querySelectorAll('.kc-faq-question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = this.closest('.kc-faq-item');
        var isOpen = item.classList.contains('open');
        SCOPE.querySelectorAll('.kc-faq-item.open').forEach(function (el) {
          el.classList.remove('open');
          var q = el.querySelector('.kc-faq-question');
          if (q) q.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('open');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ──────────────────────────
     OPTION BUTTONS
  ────────────────────────── */
  function initOptions() {
    SCOPE.querySelectorAll('.kc-options-grid').forEach(function (grid) {
      grid.querySelectorAll('.kc-option-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          grid.querySelectorAll('.kc-option-btn').forEach(function (b) { b.classList.remove('active'); });
          this.classList.add('active');
        });
      });
    });
  }

  /* ──────────────────────────
     QTY CONTROLS (product page)
  ────────────────────────── */
  function initQty() {
    SCOPE.querySelectorAll('[data-kc-delta]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = this.closest('.kc-qty-control').querySelector('.kc-qty-value');
        if (!input) return;
        var v = parseInt(input.value, 10) || 1;
        var d = parseInt(this.dataset.kcDelta, 10);
        input.value = Math.max(1, Math.min(99, v + d));
      });
    });
  }

  /* ──────────────────────────
     MOBILE NAV TOGGLE
  ────────────────────────── */
  function initMobileNav() {
    var toggle = SCOPE.querySelector('.kc-header-menu-toggle');
    var nav    = SCOPE.querySelector('.kc-header-nav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('kc-mobile-open');
      toggle.setAttribute('aria-expanded', open);
    });
  }

  /* ══════════════════════════
     CART DRAWER
  ══════════════════════════ */
  var Cart = {
    overlay: null,
    drawer:  null,
    items:   null,
    footer:  null,
    countEls: [],
    countPill: null,
    subtotalEl: null,

    init: function () {
      this.overlay   = document.querySelector('[data-kc-cart-overlay]');
      this.drawer    = document.querySelector('[data-kc-cart-drawer]');
      if (!this.drawer) return;

      this.items     = this.drawer.querySelector('[data-kc-cart-items]');
      this.footer    = this.drawer.querySelector('[data-kc-cart-footer]');
      this.countEls  = document.querySelectorAll('[data-kc-cart-count]');
      this.countPill = this.drawer.querySelector('[data-kc-cart-count-pill]');
      this.subtotalEl = this.drawer.querySelector('[data-kc-cart-subtotal]');

      var self = this;

      /* open triggers */
      document.querySelectorAll('[data-kc-cart-toggle]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          self.open();
        });
      });

      /* close triggers */
      document.querySelectorAll('[data-kc-cart-close]').forEach(function (el) {
        el.addEventListener('click', function () { self.close(); });
      });
      if (this.overlay) {
        this.overlay.addEventListener('click', function () { self.close(); });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.drawer.classList.contains('kc-open')) self.close();
      });

      /* line-item controls (event delegation, survives re-renders).
         Optimistic UI: update the displayed qty + count instantly so
         the user doesn't see the network round-trip. Multiple rapid
         clicks are debounced — only the LATEST qty is POSTed after
         300ms of quiet, so 5 fast +'s = 1 request that lands on +5. */
      this._pendingQty = {};
      this._qtyTimer = {};
      this.drawer.addEventListener('click', function (e) {
        var line = e.target.closest('[data-kc-cart-line]');
        if (!line) return;
        var key = line.dataset.kcCartLine;
        var qtyEl = line.querySelector('.kc-cart-qty-val');
        var qty = parseInt((qtyEl && qtyEl.textContent) || '1', 10);

        var delta = null;
        if (e.target.closest('[data-kc-cart-increase]')) delta = +1;
        else if (e.target.closest('[data-kc-cart-decrease]')) delta = -1;
        else if (e.target.closest('[data-kc-cart-remove]')) {
          self.changeQty(key, 0);
          return;
        }
        if (delta === null) return;

        var prev = self._pendingQty[key] != null ? self._pendingQty[key] : qty;
        var next = Math.max(0, prev + delta);
        self._pendingQty[key] = next;

        /* Optimistic UI updates — instant feedback */
        if (qtyEl) qtyEl.textContent = next;
        var priceEl = line.querySelector('[data-kc-cart-line-price]');
        var unitCents = parseInt(line.dataset.kcUnitPrice || '0', 10);
        if (priceEl && unitCents) {
          var newCents = unitCents * next;
          /* Use Shopify's money format via simple AED helper */
          priceEl.textContent = self.formatMoney ? self.formatMoney(newCents) : (newCents / 100).toFixed(2);
        }
        var countEls = document.querySelectorAll('[data-kc-cart-count]');
        var deltaInCount = next - qty;
        countEls.forEach(function (el) {
          var current = parseInt(el.textContent || '0', 10);
          var updated = Math.max(0, current + deltaInCount);
          el.textContent = updated;
          if (updated > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
        });

        /* Debounce the server call — only the latest pending qty per key
           gets POSTed after 300ms of no further clicks on that line. */
        clearTimeout(self._qtyTimer[key]);
        self._qtyTimer[key] = setTimeout(function () {
          var finalQty = self._pendingQty[key];
          delete self._pendingQty[key];
          delete self._qtyTimer[key];
          self.changeQty(key, finalQty);
        }, 300);
      });
    },

    open: function () {
      if (!this.drawer) return;
      this.refresh();
      this.overlay.classList.add('kc-open');
      this.overlay.setAttribute('aria-hidden', 'false');
      this.drawer.classList.add('kc-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      ScrollLock.acquire('cart');
    },

    close: function () {
      this.overlay.classList.remove('kc-open');
      this.overlay.setAttribute('aria-hidden', 'true');
      this.drawer.classList.remove('kc-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      ScrollLock.release('cart');
    },

    changeQty: function (key, qty) {
      var self = this;
      this._busy = this._busy || {};
      if (this._busy[key]) return;                       /* one mutation per line at a time */
      this._busy[key] = true;
      var controls = this.drawer ? this.drawer.querySelectorAll('[data-kc-line="' + key + '"] button, [data-kc-key="' + key + '"] button') : [];
      controls.forEach(function (b) { b.disabled = true; });
      var finish = function () { delete self._busy[key]; controls.forEach(function (b) { b.disabled = false; }); };

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function (r) { return r.json().then(function (cart) { return { ok: r.ok, cart: cart }; }); })
      .then(function (res) {
        var cart = res.cart;
        /* 422-style body (no items) or clamped quantity: re-sync from /cart.js and tell the customer instead of silently snapping back. */
        if (!res.ok || !cart || !cart.items) {
          self.notice((cart && (cart.description || cart.message)) || ((window.kcStrings && window.kcStrings.cartUpdateFailed) || 'Couldn’t update that item.'));
          self.refresh(); return;
        }
        var line = null;
        for (var i = 0; i < cart.items.length; i++) { if (cart.items[i].key === key) { line = cart.items[i]; break; } }
        if (line && qty > 0 && line.quantity < qty) {
          self.notice((window.kcStrings && window.kcStrings.stockLimited) || ('Only ' + line.quantity + ' available.'));
        }
        self.render(cart);
      })
      .catch(function () { self.notice((window.kcStrings && window.kcStrings.cartUpdateFailed) || 'Couldn’t update that item.'); self.refresh(); })
      .then(finish, finish);
    },
    notice: function (msg) {
      if (!this.drawer) return;
      var el = this.drawer.querySelector('.kc-cart-notice');
      if (!el) { el = document.createElement('div'); el.className = 'kc-cart-notice'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite'); this.drawer.appendChild(el); }
      el.textContent = msg; el.classList.add('kc-show');
      clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove('kc-show'); }, 3500);
    },

    refresh: function () {
      var self = this;
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { if (cart && cart.items) self.render(cart); })
        .catch(function () {});
    },

    render: function (cart) {
      var self = this;
      if (!cart || !cart.items) return;

      /* count pill + header bubble */
      this.countEls.forEach(function (el) {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
      if (this.countPill) this.countPill.textContent = cart.item_count;

      /* empty state */
      if (cart.item_count === 0) {
        this.items.innerHTML =
          '<div class="kc-cart-empty">' +
            '<div class="kc-cart-empty-icon">◈</div>' +
            '<p class="kc-cart-empty-text">' + ((window.kcStrings&&window.kcStrings.cartEmpty)||'Your cart is empty') + '</p>' +
            '<a href="' + (window.kcBuyUrl || kcLocalUrl('/products/keep-card')) + '" class="kc-cart-empty-cta">' + ((window.kcStrings&&window.kcStrings.continueShopping)||'Continue shopping →') + '</a>' +
          '</div>';
        if (this.footer) this.footer.style.display = 'none';
        return;
      }

      /* line items */
      var html = cart.items.map(function (item) {
        var img = item.image
          ? '<img src="' + item.image + '" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '">'
          : '';
        var variant = (!item.product_has_only_default_variant && item.variant_title)
          ? '<div class="kc-cart-item-variant">' + item.variant_title + '</div>'
          : '';
        return (
          '<div class="kc-cart-item" data-kc-cart-line="' + item.key + '">' +
            '<a href="' + item.url + '" class="kc-cart-item-img">' + img + '</a>' +
            '<div class="kc-cart-item-info">' +
              '<a href="' + item.url + '" class="kc-cart-item-name">' + item.product_title + '</a>' +
              variant +
              '<div class="kc-cart-item-bottom">' +
                '<div class="kc-cart-qty">' +
                  '<button type="button" class="kc-cart-qty-btn" data-kc-cart-decrease aria-label="Decrease">−</button>' +
                  '<span class="kc-cart-qty-val">' + item.quantity + '</span>' +
                  '<button type="button" class="kc-cart-qty-btn" data-kc-cart-increase aria-label="Increase">+</button>' +
                '</div>' +
                '<div class="kc-cart-item-price">' + self.money(item.final_line_price, cart.currency) + '</div>' +
              '</div>' +
              '<button type="button" class="kc-cart-remove" data-kc-cart-remove>' + ((window.kcStrings&&window.kcStrings.remove)||'Remove') + '</button>' +
            '</div>' +
          '</div>'
        );
      }).join('');
      this.items.innerHTML = html;

      /* footer + subtotal */
      if (!this.footer) {
        var f = document.createElement('div');
        f.className = 'kc-cart-footer';
        f.setAttribute('data-kc-cart-footer', '');
        f.innerHTML =
          '<div class="kc-cart-subtotal-row">' +
            '<span class="kc-cart-subtotal-label">' + ((window.kcStrings&&window.kcStrings.subtotal)||'Subtotal') + '</span>' +
            '<span class="kc-cart-subtotal-value" data-kc-cart-subtotal></span>' +
          '</div>' +
          '<p class="kc-cart-shipping-note">' + ((window.kcStrings&&window.kcStrings.shippingNote)||'Shipping & taxes calculated at checkout.') + '</p>' +
          '<form action="' + ((window.routes&&window.routes.cart_url)||'/cart') + '" method="post" novalidate>' +
            '<button type="submit" name="checkout" class="kc-cart-checkout-btn">' + ((window.kcStrings&&window.kcStrings.checkout)||'Checkout →') + '</button>' +
          '</form>' +
          '<a href="' + ((window.routes&&window.routes.cart_url)||'/cart') + '" class="kc-cart-view-link">' + ((window.kcStrings&&window.kcStrings.viewFullCart)||'View full cart') + '</a>';
        this.drawer.appendChild(f);
        this.footer = f;
        this.subtotalEl = f.querySelector('[data-kc-cart-subtotal]');
      }
      this.footer.style.display = '';
      if (this.subtotalEl) this.subtotalEl.textContent = this.money(cart.total_price, cart.currency);
    },

    money: function (cents, currency) {
      var amount = (cents / 100).toFixed(2);
      /* Arabic: number then currency word (99.00 درهم) for consistency with the
         Liquid-rendered price. Latin "AED" elsewhere. */
      var isAr = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
      var cur = isAr ? 'درهم' : (currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '');
      return cur ? (amount + ' ' + cur) : amount;
    }
  };

  /* ══════════════════════════
     ADD TO CART (product form)
  ══════════════════════════ */
  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      if (form.dataset.kcBusy === '1') return;            /* duplicate submit guard */
      form.dataset.kcBusy = '1';

      var btn = form.querySelector('[type="submit"], .kc-btn-add');
      var orig = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.innerHTML = (window.kcStrings && window.kcStrings.adding) || 'Adding…'; }
      var err = form.querySelector('.kc-form-error'); if (err) err.hidden = true;

      var fd = new FormData(form);
      var done = function () { form.dataset.kcBusy = '0'; if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: fd
      })
      .then(function (r) {
        /* Shopify answers 422 (sold out / bad variant) with a JSON body — never treat that as success. */
        return r.json().then(function (data) {
          if (!r.ok) { var e2 = new Error(data && (data.description || data.message) || 'Could not add to cart'); e2.kcUser = true; throw e2; }
          return data;
        });
      })
      .then(function () {
        if (btn) { btn.innerHTML = (window.kcStrings && window.kcStrings.added) || '✓ Added'; setTimeout(function () { btn.innerHTML = orig; }, 1500); }
        done();
        Cart.open();
      })
      .catch(function (ex) {
        if (btn) btn.innerHTML = orig;
        done();
        showFormError(form, (ex && ex.kcUser && ex.message) || ((window.kcStrings && window.kcStrings.addFailed) || 'Sorry — that couldn’t be added. Please try again.'));
      });
    });
  }

  /* ══════════════════════════
     AUTH MODAL — Sign In / Sign Up
  ══════════════════════════ */
  var Auth = {
    overlay: null,
    modal: null,
    panes: null,
    tabs: null,

    init: function () {
      this.overlay = document.querySelector('[data-kc-auth-overlay]');
      this.modal   = document.querySelector('[data-kc-auth-modal]');
      if (!this.modal) return;

      this.panes = this.modal.querySelectorAll('[data-kc-auth-pane]');
      this.tabs  = this.modal.querySelectorAll('[data-kc-auth-tab]');

      var self = this;

      /* default to signin */
      this.show('signin');

      /* triggers */
      document.querySelectorAll('[data-kc-auth-toggle]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          var pane = el.getAttribute('data-kc-auth-toggle') || 'signin';
          self.open(pane);
        });
      });

      /* close */
      document.querySelectorAll('[data-kc-auth-close]').forEach(function (el) {
        el.addEventListener('click', function () { self.close(); });
      });
      if (this.overlay) {
        this.overlay.addEventListener('click', function () { self.close(); });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.modal.classList.contains('kc-open')) self.close();
      });

      /* tabs */
      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          self.show(tab.getAttribute('data-kc-auth-tab'));
        });
      });

      /* inline switch links */
      this.modal.querySelectorAll('[data-kc-auth-switch]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          self.show(el.getAttribute('data-kc-auth-switch'));
        });
      });
      this.modal.querySelectorAll('[data-kc-auth-recover]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          self.show('recover');
        });
      });

      /* auto-open if there are server-side form errors */
      var hasErrors = this.modal.querySelector('.kc-auth-errors');
      if (hasErrors) {
        var errPane = hasErrors.closest('[data-kc-auth-pane]');
        if (errPane) {
          this.open(errPane.getAttribute('data-kc-auth-pane'));
        }
      }
      var hasSuccess = this.modal.querySelector('.kc-auth-success');
      if (hasSuccess) {
        var sucPane = hasSuccess.closest('[data-kc-auth-pane]');
        if (sucPane) {
          this.open(sucPane.getAttribute('data-kc-auth-pane'));
        }
      }
    },

    show: function (which) {
      this.panes.forEach(function (p) {
        p.classList.toggle('kc-active', p.getAttribute('data-kc-auth-pane') === which);
      });
      this.tabs.forEach(function (t) {
        t.classList.toggle('kc-active', t.getAttribute('data-kc-auth-tab') === which);
      });
    },

    open: function (which) {
      if (which) this.show(which);

      /* Bulletproof: stamp the overlay's critical visual props with
         !important via setProperty so nothing in the cached stylesheet
         (or theme app injections) can hide it. */
      var ov = this.overlay;
      var force = function (prop, val) { ov.style.setProperty(prop, val, 'important'); };
      force('position', 'fixed');
      force('top', '0');
      force('left', '0');
      force('right', '0');
      force('bottom', '0');
      force('width', '100vw');
      force('height', '100vh');
      force('background-color', 'rgba(0,0,0,0.62)');
      force('background-image', 'none');
      force('backdrop-filter', 'blur(8px) saturate(140%)');
      force('-webkit-backdrop-filter', 'blur(8px) saturate(140%)');
      force('z-index', '9998');
      force('opacity', '1');
      force('pointer-events', 'auto');
      force('display', 'block');
      force('visibility', 'visible');
      ov.classList.add('kc-open');
      ov.setAttribute('aria-hidden', 'false');

      this.modal.classList.add('kc-open');
      this.modal.setAttribute('aria-hidden', 'false');
      ScrollLock.acquire('auth');

      /* Auto-focus first input in active pane (after animation) */
      var self = this;
      setTimeout(function () {
        var activePane = self.modal.querySelector('.kc-auth-pane.kc-active');
        if (activePane) {
          var firstInput = activePane.querySelector('input:not([type="hidden"])');
          if (firstInput) firstInput.focus();
        }
      }, 350);
    },

    close: function () {
      /* Fade out the overlay, then strip every forced prop so the next
         open is clean and CSS defaults take over. */
      var ov = this.overlay;
      ov.style.setProperty('opacity', '0', 'important');
      ov.style.setProperty('pointer-events', 'none', 'important');
      ov.classList.remove('kc-open');
      ov.setAttribute('aria-hidden', 'true');
      setTimeout(function () { ov.removeAttribute('style'); }, 350);

      this.modal.classList.remove('kc-open');
      this.modal.setAttribute('aria-hidden', 'true');
      ScrollLock.release('auth');
    }
  };

  /* ══════════════════════════
     PRODUCT PAGE — variants, gallery, sticky CTA
  ══════════════════════════ */
  function initProductPage() {
    var section = SCOPE.querySelector('.kc-pp');
    if (!section) return;

    /* Image gallery */
    var mainImg = section.querySelector('#kc-pp-img');
    section.querySelectorAll('[data-kc-pp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = this.dataset.img;
        if (mainImg) {
          mainImg.style.opacity = 0;
          setTimeout(function () { mainImg.src = src; mainImg.style.opacity = 1; }, 200);
        }
        section.querySelectorAll('[data-kc-pp-thumb]').forEach(function (t) { t.classList.remove('kc-active'); });
        this.classList.add('kc-active');
      });
    });

    /* Variant data */
    var variantsScript = section.querySelector('[data-kc-variants]');
    if (!variantsScript) return;
    var variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    var optionGroups = section.querySelectorAll('[data-kc-option-grid]');
    var selected = [];

    /* Init from active buttons */
    optionGroups.forEach(function (group, idx) {
      var active = group.querySelector('.kc-pp-option-btn.kc-active');
      selected[idx] = active ? active.getAttribute('data-kc-option-value') : null;
    });

    function updateSelectedLabel(group) {
      var label = group.parentElement.querySelector('[data-kc-option-selected]');
      var active = group.querySelector('.kc-pp-option-btn.kc-active');
      if (label && active) label.textContent = active.textContent.trim();
    }

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function applyVariant(v) {
      if (!v) return;
      var idInput = section.querySelector('[data-kc-variant-id]');
      var priceEl = section.querySelector('[data-kc-price]');
      var compareEl = section.querySelector('[data-kc-compare]');
      var ctaPriceEl = section.querySelector('[data-kc-cta-price]');
      var addBtn = section.querySelector('[data-kc-add]');

      if (idInput) idInput.value = v.id;
      var fmt = function (cents) { return Cart.money(cents, window.Shopify && window.Shopify.currency && window.Shopify.currency.active); };
      if (priceEl) priceEl.textContent = fmt(v.price);
      if (compareEl) compareEl.textContent = v.compare_at_price > v.price ? fmt(v.compare_at_price) : '';
      if (ctaPriceEl) ctaPriceEl.textContent = fmt(v.price);
      /* sync sticky bottom bar */
      var bbPrice = SCOPE.querySelector('[data-kc-bb-price]');
      if (bbPrice) bbPrice.textContent = fmt(v.price);
      var bbAdd = SCOPE.querySelector('[data-kc-bb-add]');
      if (bbAdd) {
        bbAdd.disabled = !v.available;
        bbAdd.textContent = v.available ? ((window.kcStrings && window.kcStrings.addToCart) || 'Add to Cart') : ((window.kcStrings && window.kcStrings.soldOut) || 'Sold Out');
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (!v.available) addBtn.textContent = (window.kcStrings && window.kcStrings.soldOut) || 'Sold Out';
      }
      /* The PDP's own button is [data-kc-atc] (not [data-kc-add]) — keep it in sync too. */
      var atc = section.querySelector('[data-kc-atc]'), atcText = section.querySelector('[data-kc-atc-text]');
      if (atc) {
        if (!atc.dataset.kcLabel && atcText) atc.dataset.kcLabel = atcText.textContent;
        atc.disabled = !v.available;
        if (atcText) atcText.textContent = v.available ? (atc.dataset.kcLabel || atcText.textContent) : ((window.kcStrings && window.kcStrings.soldOut) || 'Sold Out');
      }
      /* Jump the gallery to the slide that matches this variant's
         featured image. Matches by Shopify CDN filename (path basename
         before the `?` query) because srcs vary by width-transform. */
      if (v.featured_image) {
        var imgUrl = (typeof v.featured_image === 'string' ? v.featured_image : v.featured_image.src);
        if (imgUrl) {
          var key = imgUrl.split('?')[0].split('/').pop();
          var gal = SCOPE.querySelector('.kc-gal');
          if (gal && typeof gal.kcGoToSlide === 'function') {
            var slideImgs = gal.querySelectorAll('.kc-gal-slide [data-kc-gal-img], .kc-gal-slide img');
            for (var i = 0; i < slideImgs.length; i++) {
              var s = (slideImgs[i].currentSrc || slideImgs[i].src || '');
              if (s.split('?')[0].split('/').pop() === key) { gal.kcGoToSlide(i); break; }
            }
          }
        }
      }
    }

    optionGroups.forEach(function (group, idx) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.kc-pp-option-btn');
        if (!btn) return;
        group.querySelectorAll('.kc-pp-option-btn').forEach(function (b) { b.classList.remove('kc-active'); });
        btn.classList.add('kc-active');
        selected[idx] = btn.getAttribute('data-kc-option-value');
        updateSelectedLabel(group);
        applyVariant(findVariant());
      });
    });
  }

  /* ══════════════════════════
     CART PAGE — qty + remove via AJAX
  ══════════════════════════ */
  function initCartPage() {
    var page = SCOPE.querySelector('.kc-cp');
    if (!page) return;

    page.querySelectorAll('.kc-cp-item').forEach(function (item) {
      var line = item.dataset.line;
      var input = item.querySelector('[data-kc-cp-qty-input]');

      function changeQty(qty) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
        }).then(function () { window.location.reload(); })
          .catch(function () { window.location.reload(); });
      }

      var dec = item.querySelector('[data-kc-cp-decrease]');
      var inc = item.querySelector('[data-kc-cp-increase]');
      var rem = item.querySelector('[data-kc-cp-remove]');

      if (dec) dec.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        changeQty(Math.max(0, v - 1));
      });
      if (inc) inc.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        changeQty(v + 1);
      });
      if (rem) rem.addEventListener('click', function () {
        changeQty(0);
      });
    });
  }

  /* ══════════════════════════
     FREE-SHIPPING PROGRESS BAR (cart drawer)
  ══════════════════════════ */
  function updateShipbar(totalCents) {
    var bar = SCOPE.querySelector('[data-kc-shipbar]');
    if (!bar) return;
    var threshold = parseInt(bar.dataset.threshold, 10) || 5000;
    var current = totalCents != null ? totalCents : (parseInt(bar.dataset.current, 10) || 0);
    var pct = Math.min(100, (current / threshold) * 100);
    var fill = bar.querySelector('[data-kc-shipbar-fill]');
    var text = bar.querySelector('[data-kc-shipbar-text]');
    if (fill) fill.style.width = pct + '%';
    if (text) {
      if (current >= threshold) {
        text.innerHTML = '🎉 <strong>' + ((window.kcStrings&&window.kcStrings.freeShipUnlocked)||'You unlocked free shipping!') + '</strong>';
      } else {
        var remaining = ((threshold - current) / 100).toFixed(2);
        var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
        text.innerHTML = ((window.kcStrings && window.kcStrings.freeShipProgress) || 'Add <strong>[amount]</strong> for free shipping').replace('[amount]', remaining + ' ' + cur);
      }
    }
  }

  /* hook into cart render */
  var origRender = null;
  function hookCartRender() {
    if (typeof Cart !== 'undefined' && Cart.render && !origRender) {
      origRender = Cart.render.bind(Cart);
      Cart.render = function (cart) {
        origRender(cart);
        updateShipbar(cart.total_price);
      };
    }
  }

  /* ══════════════════════════
     MOBILE MENU DRAWER
  ══════════════════════════ */
  var MobileMenu = {
    overlay: null, panel: null,
    init: function () {
      this.overlay = document.querySelector('[data-kc-mm-overlay]');
      this.panel   = document.querySelector('[data-kc-mm-panel]');
      if (!this.panel) return;
      var self = this;
      document.querySelectorAll('[data-kc-mm-toggle]').forEach(function (b) {
        b.addEventListener('click', function () { self.toggle(); });
      });
      document.querySelectorAll('[data-kc-mm-close]').forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });
      this.overlay.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.panel.classList.contains('kc-open')) self.close();
      });
      /* close after tapping any nav link */
      this.panel.querySelectorAll('.kc-mm-link, [data-kc-mm-close-trigger]').forEach(function (a) {
        a.addEventListener('click', function () { self.close(); });
      });
    },
    toggle: function () { this.panel.classList.contains('kc-open') ? this.close() : this.open(); },
    open: function () {
      this.overlay.classList.add('kc-open');
      this.overlay.setAttribute('aria-hidden', 'false');
      this.panel.classList.add('kc-open');
      this.panel.setAttribute('aria-hidden', 'false');
      ScrollLock.acquire('menu'); document.body.classList.add('kc-mm-open');
      hapticTap();
    },
    close: function () {
      this.overlay.classList.remove('kc-open');
      this.overlay.setAttribute('aria-hidden', 'true');
      this.panel.classList.remove('kc-open');
      this.panel.setAttribute('aria-hidden', 'true');
      ScrollLock.release('menu'); document.body.classList.remove('kc-mm-open');
    }
  };

  /* ══════════════════════════
     SEARCH OVERLAY (mobile)
  ══════════════════════════ */
  var SearchOverlay = {
    overlay: null, input: null, recentEl: null, recentList: null,
    resultsEl: null, resultsList: null, emptyEl: null,
    timer: null,
    KEY: 'kc_recent_searches',

    init: function () {
      this.overlay = document.querySelector('[data-kc-so-overlay]');
      if (!this.overlay) return;
      this.input       = this.overlay.querySelector('[data-kc-so-input]');
      this.recentEl    = this.overlay.querySelector('[data-kc-so-recent]');
      this.recentList  = this.overlay.querySelector('[data-kc-so-recent-list]');
      this.resultsEl   = this.overlay.querySelector('[data-kc-so-results]');
      this.resultsList = this.overlay.querySelector('[data-kc-so-results-list]');
      this.emptyEl     = this.overlay.querySelector('[data-kc-so-empty]');

      var self = this;
      document.querySelectorAll('[data-kc-so-toggle]').forEach(function (b) {
        b.addEventListener('click', function () { self.open(); });
      });
      document.querySelectorAll('[data-kc-so-close]').forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.overlay.classList.contains('kc-open')) self.close();
      });

      this.input.addEventListener('input', function () {
        clearTimeout(self.timer);
        self.timer = setTimeout(function () { self.search(self.input.value); }, 200);
      });
      this.overlay.querySelector('.kc-so-form').addEventListener('submit', function (e) {
        var q = self.input.value.trim();
        if (q) self.saveRecent(q);
        /* let it submit normally to /search */
      });
    },

    open: function () {
      this.overlay.classList.add('kc-open');
      this.overlay.setAttribute('aria-hidden', 'false');
      ScrollLock.acquire('search');
      this.renderRecent();
      var self = this;
      setTimeout(function () { self.input.focus(); }, 150);
      hapticTap();
    },
    close: function () {
      this.overlay.classList.remove('kc-open');
      this.overlay.setAttribute('aria-hidden', 'true');
      ScrollLock.release('search');
    },

    saveRecent: function (q) {
      try {
        var arr = JSON.parse(localStorage.getItem(this.KEY) || '[]');
        arr = arr.filter(function (x) { return x !== q; });
        arr.unshift(q); arr = arr.slice(0, 5);
        localStorage.setItem(this.KEY, JSON.stringify(arr));
      } catch (e) {}
    },
    renderRecent: function () {
      var arr = [];
      try { arr = JSON.parse(localStorage.getItem(this.KEY) || '[]'); } catch (e) {}
      if (!arr.length) { this.recentEl.style.display = 'none'; return; }
      this.recentEl.style.display = '';
      this.recentList.innerHTML = arr.map(function (q) {
        return '<a href="/search?q=' + encodeURIComponent(q) + '" class="kc-so-recent-item"><span>' + q + '</span></a>';
      }).join('');
    },

    search: function (q) {
      q = (q || '').trim();
      if (!q) {
        this.resultsEl.style.display = 'none';
        this.emptyEl.style.display = 'none';
        this.renderRecent();
        return;
      }
      this.recentEl.style.display = 'none';
      var self = this;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8', {
        headers: { 'Accept': 'application/json' }
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          self.resultsEl.style.display = 'none';
          self.emptyEl.style.display = '';
          return;
        }
        self.emptyEl.style.display = 'none';
        self.resultsEl.style.display = '';
        self.resultsList.innerHTML = products.map(function (p) {
          var img = p.image ? '<div class="kc-so-result-img"><img src="' + p.image + '" alt=""></div>' : '<div class="kc-so-result-img"></div>';
          return '<a href="' + p.url + '" class="kc-so-result">' +
                   img +
                   '<span class="kc-so-result-title">' + p.title + '</span>' +
                   '<span class="kc-so-result-price">' + (p.price || '') + '</span>' +
                 '</a>';
        }).join('');
      })
      .catch(function () {});
    }
  };

  /* ══════════════════════════
     STICKY BOTTOM Add-to-Cart (mobile, product page)
  ══════════════════════════ */
  var BottomBar = {
    el: null, observer: null,
    init: function () {
      this.el = SCOPE.querySelector('[data-kc-bb]');
      if (!this.el) return;

      var self = this;
      if (this.el.dataset.kcBound) return;           /* idempotent across section reloads */
      this.el.dataset.kcBound = '1';
      var btn = this.el.querySelector('[data-kc-bb-add]');
      if (btn) btn.addEventListener('click', function () {
        /* Delegate to the real product form so one code path adds to cart. */
        var submit = document.querySelector('.kc-pp-buy-form [data-kc-atc], .kc-pp-buy-form [type="submit"], .kc-pp-form [data-kc-add]');
        if (submit && !submit.disabled) submit.click();
        hapticTap();
      });

      /* Show the bar only while the in-page Add-to-Cart is scrolled out of view.
         (The PDP button is [data-kc-atc]; the old [data-kc-add]-only lookup never
         matched, so the bar never appeared.) body.kc-bb-visible lets CSS lift the
         WhatsApp FAB / toasts above the bar. */
      var origin = document.querySelector('[data-kc-atc], [data-kc-add]');
      if (!origin) return;
      this.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0 || (!entry.isIntersecting && entry.boundingClientRect.top > window.innerHeight);
          self.el.classList.toggle('kc-show', show);
          self.el.setAttribute('aria-hidden', show ? 'false' : 'true');
          document.body.classList.toggle('kc-bb-visible', show);
        });
      }, { rootMargin: '-50px 0px 0px 0px' });
      this.observer.observe(origin);
    },
    syncPrice: function (cents, currency) {
      if (!this.el) return;
      var p = this.el.querySelector('[data-kc-bb-price]');
      if (p) p.textContent = Cart.money(cents, currency);
    }
  };

  /* ══════════════════════════
     HAPTIC FEEDBACK (where supported)
  ══════════════════════════ */
  function hapticTap(duration) {
    try {
      if (navigator.vibrate) navigator.vibrate(duration || 8);
    } catch (e) {}
  }

  /* ══════════════════════════
     WEB SHARE (product pages)
  ══════════════════════════ */
  function initShare() {
    if (!navigator.share) return;
    var btn = SCOPE.querySelector('[data-kc-share]');
    if (!btn) return;
    btn.style.display = '';
    btn.addEventListener('click', function () {
      navigator.share({
        title: document.title,
        text: SCOPE.querySelector('meta[name="description"]') ? SCOPE.querySelector('meta[name="description"]').content : '',
        url: window.location.href
      }).catch(function () {});
    });
  }

  /* ══════════════════════════
     DESKTOP-ONLY: 3D card tilt
  ══════════════════════════ */
  function isHoverCapable() {
    return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  /* ══════════════════════════
     EXIT-INTENT POPUP
     - Desktop: trigger on mouseleave to top
     - Mobile: trigger on aggressive scroll-up after deep scroll
     - Cooldown: don't show again for 7 days after dismiss
  ══════════════════════════ */
  var ExitIntent = {
    overlay: null, modal: null, KEY: 'kc_ei_seen',
    init: function () {
      this.overlay = document.querySelector('[data-kc-ei-overlay]');
      this.modal   = document.querySelector('[data-kc-ei]');
      if (!this.modal) return;

      var seen = 0;
      try { seen = parseInt(localStorage.getItem(this.KEY) || '0', 10); } catch (e) {}
      var SEVEN_DAYS = 7 * 24 * 60 * 60 * 1000;
      if (seen && (Date.now() - seen) < SEVEN_DAYS) return;

      var self = this;
      var triggered = false;

      function trigger() {
        if (triggered) return;
        /* Never stack on top of another open overlay (cart, menu, auth, search…). */
        if (Object.keys(ScrollLock._held).length) return;
        triggered = true;
        self.open();
      }

      /* Desktop: cursor leaving viewport top */
      document.addEventListener('mouseleave', function (e) {
        if (e.clientY < 10) trigger();
      });

      /* Mobile: scroll fast upward after going deep */
      var lastY = window.scrollY, deepest = 0;
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        if (y > deepest) deepest = y;
        if (deepest > 800 && y < lastY - 80 && y < 200) trigger();
        lastY = y;
      }, { passive: true });

      /* Close handlers */
      document.querySelectorAll('[data-kc-ei-close]').forEach(function (el) {
        el.addEventListener('click', function () { self.close(); });
      });
      if (this.overlay) this.overlay.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.modal.classList.contains('kc-open')) self.close();
      });
    },
    open: function () {
      this.overlay.classList.add('kc-open');
      this.modal.classList.add('kc-open');
      this.modal.setAttribute('aria-hidden', 'false');
      try { localStorage.setItem(this.KEY, Date.now().toString()); } catch (e) {}
    },
    close: function () {
      this.overlay.classList.remove('kc-open');
      this.modal.classList.remove('kc-open');
      this.modal.setAttribute('aria-hidden', 'true');
    }
  };

  /* ══════════════════════════
     QUICK VIEW MODAL
     - Click .kc-pc-qv on collection card → fetch /products/handle.js → render in modal
  ══════════════════════════ */
  var QuickView = {
    overlay: null, modal: null, body: null,
    init: function () {
      this.overlay = document.querySelector('[data-kc-qv-overlay]');
      this.modal   = document.querySelector('[data-kc-qv]');
      this.body    = document.querySelector('[data-kc-qv-body]');
      if (!this.modal) return;

      var self = this;
      document.querySelectorAll('[data-kc-qv-open]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var handle = btn.dataset.handle;
          if (handle) self.load(handle);
        });
      });
      document.querySelectorAll('[data-kc-qv-close]').forEach(function (el) {
        el.addEventListener('click', function () { self.close(); });
      });
      if (this.overlay) this.overlay.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.modal.classList.contains('kc-open')) self.close();
      });
    },
    load: function (handle) {
      this.body.innerHTML = '<div class="kc-qv-loading">' + ((window.kcStrings&&window.kcStrings.loading)||'Loading…') + '</div>';
      this.open();
      var self = this;
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) { self.render(p); })
        .catch(function () { self.body.innerHTML = '<div class="kc-qv-loading">' + ((window.kcStrings&&window.kcStrings.loadFailed)||'Failed to load product.') + '</div>'; });
    },
    render: function (p) {
      var img = p.featured_image
        ? '<img src="' + p.featured_image + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '">'
        : '';
      var compare = (p.compare_at_price && p.compare_at_price > p.price)
        ? ' <span style="color:#888;text-decoration:line-through;font-size:1rem;margin-left:8px;">' + Cart.money(p.compare_at_price, window.Shopify && window.Shopify.currency && window.Shopify.currency.active) + '</span>'
        : '';
      var html =
        '<div class="kc-qv-content">' +
          '<div class="kc-qv-img">' + img + '</div>' +
          '<div class="kc-qv-info">' +
            '<h2 class="kc-qv-title">' + p.title + '</h2>' +
            '<div class="kc-qv-price">' + Cart.money(p.price, window.Shopify && window.Shopify.currency && window.Shopify.currency.active) + compare + '</div>' +
            '<p class="kc-qv-desc">' + (p.description || '').replace(/<[^>]+>/g, '').slice(0, 220) + (p.description && p.description.length > 220 ? '…' : '') + '</p>' +
            '<div class="kc-qv-actions">' +
              '<button type="button" class="kc-qv-add" data-variant-id="' + (p.variants[0] ? p.variants[0].id : '') + '">' + ((window.kcStrings&&window.kcStrings.addToCart)||'Add to Cart') + '</button>' +
              '<a href="' + p.url + '" class="kc-qv-link">' + ((window.kcStrings&&window.kcStrings.viewDetails)||'View full details →') + '</a>' +
            '</div>' +
          '</div>' +
        '</div>';
      this.body.innerHTML = html;
      var addBtn = this.body.querySelector('.kc-qv-add');
      var self = this;
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var vid = addBtn.dataset.variantId;
          if (!vid) return;
          addBtn.disabled = true; addBtn.textContent = (window.kcStrings && window.kcStrings.adding) || 'Adding…';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: vid, quantity: 1 })
          })
          .then(function (r) { return r.json(); })
          .then(function () {
            self.close();
            if (typeof Cart !== 'undefined' && Cart.open) Cart.open();
          })
          .catch(function () { addBtn.disabled = false; addBtn.textContent = (window.kcStrings && window.kcStrings.addToCart) || 'Add to Cart'; });
        });
      }
    },
    open: function () {
      this.overlay.classList.add('kc-open');
      this.modal.classList.add('kc-open');
      this.modal.setAttribute('aria-hidden', 'false');
      ScrollLock.acquire('quickview');
    },
    close: function () {
      this.overlay.classList.remove('kc-open');
      this.modal.classList.remove('kc-open');
      this.modal.setAttribute('aria-hidden', 'true');
      ScrollLock.release('quickview');
    }
  };

  /* ══════════════════════════
     BUNDLE CALCULATOR (frequently-bought-together)
  ══════════════════════════ */
  function initBundle() {
    var section = SCOPE.querySelector('.kc-bd');
    if (!section) return;

    var checks  = section.querySelectorAll('[data-kc-bd-check]');
    var totalEl = section.querySelector('[data-kc-bd-total]');
    var addBtn  = section.querySelector('[data-kc-bd-add]');

    function recalc() {
      var sum = 0;
      checks.forEach(function (c) {
        if (c.checked) sum += parseInt(c.dataset.price, 10) || 0;
      });
      if (totalEl) totalEl.textContent = Cart.money(sum, window.Shopify && window.Shopify.currency && window.Shopify.currency.active);
    }

    checks.forEach(function (c) {
      c.addEventListener('change', function () {
        var card = c.closest('.kc-bd-card');
        if (card) card.classList.toggle('kc-active', c.checked);
        recalc();
      });
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var ids = [];
        checks.forEach(function (c) {
          if (c.checked && c.dataset.variantId) {
            ids.push({ id: parseInt(c.dataset.variantId, 10), quantity: 1 });
          }
        });
        if (!ids.length) return;
        addBtn.disabled = true; addBtn.textContent = (window.kcStrings && window.kcStrings.adding) || 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: ids })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          addBtn.textContent = '✓ Added!';
          setTimeout(function () { addBtn.textContent = (window.kcStrings && window.kcStrings.addBundle) || 'Add Bundle to Cart'; addBtn.disabled = false; }, 1500);
          if (typeof Cart !== 'undefined' && Cart.open) Cart.open();
        })
        .catch(function () { addBtn.disabled = false; addBtn.textContent = (window.kcStrings && window.kcStrings.addBundle) || 'Add Bundle to Cart'; });
      });
    }
  }

  /* ══════════════════════════
     PRODUCT GALLERY (kc-gal) — swiper + thumbs + counter + dots
  ══════════════════════════ */
  function initGallery() {
    var gal = SCOPE.querySelector('.kc-gal');
    if (!gal) return;

    var viewer   = gal.querySelector('[data-kc-gal-viewer]');
    var track    = gal.querySelector('[data-kc-gal-track]');
    var slides   = gal.querySelectorAll('.kc-gal-slide');
    var thumbs   = gal.querySelectorAll('[data-kc-gal-thumb]');
    var dots     = gal.querySelectorAll('[data-kc-gal-dot]');
    var prev     = gal.querySelector('[data-kc-gal-prev]');
    var next     = gal.querySelector('[data-kc-gal-next]');
    var current  = gal.querySelector('[data-kc-gal-current]');
    var zoomBtn  = gal.querySelector('[data-kc-gal-zoom]');
    var total    = slides.length;
    var idx      = 0;

    if (!track || total < 1) return;

    var isMobile = function () { return window.matchMedia('(max-width: 900px)').matches; };

    function go(i) {
      idx = Math.max(0, Math.min(total - 1, i));
      if (isMobile() && viewer) {
        /* Mobile uses native scroll-snap — set scrollLeft instead of
           fighting the browser with transform. */
        viewer.scrollTo({ left: idx * viewer.clientWidth, behavior: 'smooth' });
      } else {
        track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      }
      thumbs.forEach(function (t, k) { t.classList.toggle('kc-active', k === idx); });
      dots.forEach(function (d, k) { d.classList.toggle('kc-active', k === idx); });
      if (current) current.textContent = idx + 1;
      var activeThumb = thumbs[idx];
      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
    }

    /* Expose go() so initProductPage can jump the gallery to the
       slide that matches a chosen variant's featured image. */
    gal.kcGoToSlide = go;

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.dataset.index, 10) || 0); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.dataset.index, 10) || 0); });
    });
    /* Arrows loop: wrap from first->last and last->first. */
    if (prev) prev.addEventListener('click', function () { go(idx <= 0 ? total - 1 : idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx >= total - 1 ? 0 : idx + 1); });

    /* Mobile: when user swipes natively, sync index from scrollLeft. */
    if (viewer) {
      var scrollTimer = null;
      viewer.addEventListener('scroll', function () {
        if (!isMobile()) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var w = viewer.clientWidth;
          if (!w) return;
          var newIdx = Math.round(viewer.scrollLeft / w);
          if (newIdx !== idx) {
            idx = newIdx;
            thumbs.forEach(function (t, k) { t.classList.toggle('kc-active', k === idx); });
            dots.forEach(function (d, k) { d.classList.toggle('kc-active', k === idx); });
            if (current) current.textContent = idx + 1;
          }
        }, 80);
      }, { passive: true });
    }

    /* Keyboard navigation when gallery is focused or hovered */
    gal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  go(idx - 1);
      if (e.key === 'ArrowRight') go(idx + 1);
    });

    /* Lightbox open from zoom button OR click on main image */
    function openLightbox() {
      var images = Array.prototype.map.call(slides, function (s) {
        var img = s.querySelector('img');
        return img ? img.src : '';
      }).filter(Boolean);
      Lightbox.open(images, idx);
    }
    if (zoomBtn) zoomBtn.addEventListener('click', openLightbox);
    slides.forEach(function (s) {
      s.addEventListener('click', function (e) {
        if (e.target.tagName === 'IMG') openLightbox();
      });
    });
  }

  /* ══════════════════════════
     LIGHTBOX — fullscreen image viewer with prev/next/ESC/swipe
  ══════════════════════════ */
  var Lightbox = {
    el: null, img: null, currentEl: null, totalEl: null,
    images: [], idx: 0,
    init: function () {
      this.el        = document.querySelector('[data-kc-lb]');
      if (!this.el) return;
      this.img       = this.el.querySelector('[data-kc-lb-img]');
      this.currentEl = this.el.querySelector('[data-kc-lb-current]');
      this.totalEl   = this.el.querySelector('[data-kc-lb-total]');

      var self = this;
      var closeBtn = this.el.querySelector('[data-kc-lb-close]');
      var prev     = this.el.querySelector('[data-kc-lb-prev]');
      var next     = this.el.querySelector('[data-kc-lb-next]');
      if (closeBtn) closeBtn.addEventListener('click', function () { self.close(); });
      if (prev)     prev.addEventListener('click',     function () { self.go(self.idx - 1); });
      if (next)     next.addEventListener('click',     function () { self.go(self.idx + 1); });
      document.addEventListener('keydown', function (e) {
        if (!self.el.classList.contains('kc-open')) return;
        if (e.key === 'Escape')      self.close();
        if (e.key === 'ArrowLeft')   self.go(self.idx - 1);
        if (e.key === 'ArrowRight')  self.go(self.idx + 1);
      });
      this.el.addEventListener('click', function (e) {
        if (e.target === self.el) self.close();
      });

      /* Swipe on mobile */
      var startX = null;
      this.el.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      this.el.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var diff = e.changedTouches[0].clientX - startX;
        if (Math.abs(diff) > 50) {
          if (diff < 0) self.go(self.idx + 1);
          else self.go(self.idx - 1);
        }
        startX = null;
      });
    },
    open: function (images, idx) {
      if (!this.el) return;
      this.images = images || [];
      if (this.images.length === 0) return;
      this.go(idx || 0);
      if (this.totalEl) this.totalEl.textContent = this.images.length;
      this.el.classList.add('kc-open');
      this.el.setAttribute('aria-hidden', 'false');
      ScrollLock.acquire('lightbox');
    },
    close: function () {
      this.el.classList.remove('kc-open');
      this.el.setAttribute('aria-hidden', 'true');
      ScrollLock.release('lightbox');
    },
    go: function (i) {
      var len = this.images.length;
      if (len === 0) return;
      this.idx = ((i % len) + len) % len; /* loop both ways */
      if (this.img) this.img.src = this.images[this.idx];
      if (this.currentEl) this.currentEl.textContent = this.idx + 1;
    }
  };

  /* ══════════════════════════
     COOKIE CONSENT BANNER
  ══════════════════════════ */
  var Cookies = {
    KEY: 'kc_cookie_consent',
    init: function () {
      var banner = SCOPE.querySelector('[data-kc-cookie]');
      if (!banner) return;
      var stored;
      try { stored = localStorage.getItem(this.KEY); } catch (e) {}
      if (stored) {
        if (stored === 'accepted' && window.kcGrantConsent) window.kcGrantConsent();
        return;
      }
      setTimeout(function () { banner.classList.add('kc-open'); banner.setAttribute('aria-hidden', 'false'); }, 800);

      var self = this;
      banner.querySelector('[data-kc-cookie-accept]').addEventListener('click', function () { self.set('accepted'); banner.classList.remove('kc-open'); });
      banner.querySelector('[data-kc-cookie-reject]').addEventListener('click', function () { self.set('rejected'); banner.classList.remove('kc-open'); });
    },
    set: function (v) {
      try { localStorage.setItem(this.KEY, v); } catch (e) {}
      if (v === 'accepted' && window.kcGrantConsent) window.kcGrantConsent();
      if (v === 'rejected' && window.kcRevokeConsent) window.kcRevokeConsent();
    }
  };

  /* ══════════════════════════
     LIVE SALES TOAST
     Cycles through admin-configured names every 25-45s
  ══════════════════════════ */
  function initLiveSales() {
    var toast = SCOPE.querySelector('[data-kc-livesale]');
    if (!toast) return;
    var rawNames = (window.__kcLiveSaleNames || '').trim();
    if (!rawNames) return;
    var names = rawNames.split(/\r?\n/).filter(function (n) { return n.trim().length > 0; });
    if (names.length === 0) return;

    var nameEl = toast.querySelector('[data-kc-livesale-name]');
    var restEl = toast.querySelector('[data-kc-livesale-rest]');
    var closeBtn = toast.querySelector('[data-kc-livesale-close]');
    var idx = 0;
    var dismissed = false;
    var hideTimer = null;

    var actions = [
      ' just ordered a Keep Card',
      ' bought a card 2 min ago',
      ' purchased 12 min ago',
      ' just signed up for early access'
    ];

    function show() {
      if (dismissed) return;
      /* Skip this tick while any overlay is open — a toast must never sit on the cart/menu. */
      if (Object.keys(ScrollLock._held).length) return;
      var name = names[idx % names.length].trim();
      var rest = actions[Math.floor(Math.random() * actions.length)];
      nameEl.textContent = name;
      restEl.textContent = rest;
      toast.classList.add('kc-open');
      toast.setAttribute('aria-hidden', 'false');
      idx++;
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, 6500);
    }
    function hide() {
      toast.classList.remove('kc-open');
      toast.setAttribute('aria-hidden', 'true');
      if (!dismissed) {
        var nextDelay = 22000 + Math.floor(Math.random() * 20000);
        setTimeout(show, nextDelay);
      }
    }

    if (closeBtn) closeBtn.addEventListener('click', function () {
      dismissed = true;
      hide();
      try { sessionStorage.setItem('kc_livesale_dismissed', '1'); } catch (e) {}
    });

    try { if (sessionStorage.getItem('kc_livesale_dismissed')) return; } catch (e) {}

    // First show after 8-15s
    setTimeout(show, 8000 + Math.floor(Math.random() * 7000));
  }

  /* ══════════════════════════
     HELP CENTER — searchable FAQ
  ══════════════════════════ */
  function initHelpSearch() {
    var input = SCOPE.querySelector('[data-kc-help-search]');
    var emptyEl = SCOPE.querySelector('[data-kc-help-empty]');
    var emptyQ = SCOPE.querySelector('[data-kc-help-empty-q]');
    var categories = SCOPE.querySelectorAll('.kc-help-cat');
    var items = SCOPE.querySelectorAll('.kc-help-item');
    if (!input || items.length === 0) return;

    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var visibleCount = 0;

      items.forEach(function (item) {
        var text = (item.dataset.q || '') + ' ' + item.textContent.toLowerCase();
        var match = !q || text.indexOf(q) !== -1;
        item.style.display = match ? '' : 'none';
        if (match) visibleCount++;
      });

      // Hide empty categories
      categories.forEach(function (cat) {
        var visible = cat.querySelectorAll('.kc-help-item:not([style*="display: none"])');
        cat.style.display = visible.length === 0 ? 'none' : '';
      });

      if (emptyEl) {
        if (visibleCount === 0 && q) {
          emptyEl.removeAttribute('hidden');
          if (emptyQ) emptyQ.textContent = input.value;
        } else {
          emptyEl.setAttribute('hidden', '');
        }
      }
    });
  }

  /* ══════════════════════════
     ORDER TRACKING — redirects to Shopify's order lookup
  ══════════════════════════ */
  function initOrderTrack() {
    var form = SCOPE.querySelector('[data-kc-track-form]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var orderNum = (form.querySelector('[data-kc-track-order]').value || '').trim().replace(/^#/, '');
      var email = (form.querySelector('[data-kc-track-email]').value || '').trim();
      var hint = form.querySelector('[data-kc-track-hint]');
      if (!orderNum || !email) {
        if (hint) { hint.hidden = false; hint.textContent = 'Please enter both your order number and email.'; }
        return;
      }
      // Shopify's order status URL pattern. Customer must verify via email link.
      window.location.href = '/account/login?checkout_url=' + encodeURIComponent('/account/orders');
    });
  }

  /* ══════════════════════════
     HIDE hCAPTCHA TEXT NOTICE
     CSS can't filter by text content, so this scans for the
     "Protected by hCaptcha..." line and hides any container holding it.
  ══════════════════════════ */
  function hideHCaptchaNotice() {
    /* Shopify injects captcha notice via async script — keep scanning */
    var RX = /protected by|hcaptcha|h-captcha|recaptcha|cloudflare turnstile/i;
    function sweep(root) {
      if (!root || !root.querySelectorAll) return;
      var all = root.querySelectorAll('p, small, span, div, a, label, li, td, footer');
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (el.dataset && el.dataset.kcCaptchaHid === '1') continue;
        if (el.children && el.children.length > 5) continue;
        var txt = (el.textContent || '').trim();
        if (txt.length > 0 && txt.length < 280 && RX.test(txt)) {
          el.style.cssText += 'display:none !important;visibility:hidden !important;height:0 !important;overflow:hidden !important;';
          if (el.dataset) el.dataset.kcCaptchaHid = '1';
        }
      }
    }
    sweep(document);

    /* Re-scan every 400ms for the first 20 seconds — beats Shopify's async injection */
    var attempts = 0;
    var interval = setInterval(function () {
      sweep(document);
      attempts++;
      if (attempts >= 50) clearInterval(interval);
    }, 400);

    /* Long-term: MutationObserver for anything injected later */
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i];
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (n.nodeType === 1) sweep(n);
          }
        }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  /* ══════════════════════════
     HERO MOUSE PARALLAX
     Updates --kc-mx / --kc-my CSS vars on .kc-hero as cursor moves,
     driving the grid drift + spotlight radial gradient.
  ══════════════════════════ */
  function initHeroParallax() {
    var hero = SCOPE.querySelector('.kc-hero');
    if (!hero) return;
    if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    hero.classList.add('kc-hero-interactive');

    var ticking = false;
    var lastX = 50, lastY = 50;

    function update() {
      hero.style.setProperty('--kc-mx', lastX + '%');
      hero.style.setProperty('--kc-my', lastY + '%');
      ticking = false;
    }

    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      lastX = ((e.clientX - r.left) / r.width) * 100;
      lastY = ((e.clientY - r.top) / r.height) * 100;
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    });

    /* Smooth-return to center when cursor leaves */
    hero.addEventListener('mouseleave', function () {
      var startX = lastX, startY = lastY;
      var t0 = performance.now();
      function animate(now) {
        var t = Math.min(1, (now - t0) / 600);
        var ease = 1 - Math.pow(1 - t, 3);
        lastX = startX + (50 - startX) * ease;
        lastY = startY + (50 - startY) * ease;
        update();
        if (t < 1) requestAnimationFrame(animate);
      }
      requestAnimationFrame(animate);
    });
  }

  /* ══════════════════════════
     ACCOUNT DROPDOWN (logged-in user menu)
  ══════════════════════════ */
  var AccountDropdown = {
    wrap: null, toggle: null, dd: null,
    init: function () {
      this.wrap = document.querySelector('[data-kc-account]');
      if (!this.wrap) return;
      this.toggle = this.wrap.querySelector('[data-kc-account-toggle]');
      this.dd     = this.wrap.querySelector('[data-kc-account-dd]');
      if (!this.toggle || !this.dd) return;

      var self = this;
      this.toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        self.wrap.classList.contains('kc-open') ? self.close() : self.open();
      });
      /* close on outside click */
      document.addEventListener('click', function (e) {
        if (self.wrap.classList.contains('kc-open') && !self.wrap.contains(e.target)) self.close();
      });
      /* close on ESC */
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.wrap.classList.contains('kc-open')) self.close();
      });
      /* close when clicking a link inside */
      this.dd.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { self.close(); });
      });
    },
    open: function () {
      this.wrap.classList.add('kc-open');
      this.toggle.setAttribute('aria-expanded', 'true');
      this.dd.setAttribute('aria-hidden', 'false');
    },
    close: function () {
      this.wrap.classList.remove('kc-open');
      this.toggle.setAttribute('aria-expanded', 'false');
      this.dd.setAttribute('aria-hidden', 'true');
    }
  };

  /* ══════════════════════════
     FILTER DRAWER (collection page)
  ══════════════════════════ */
  var FilterDrawer = {
    overlay: null, panel: null, form: null,
    init: function () {
      this.overlay = document.querySelector('[data-kc-fd-overlay]');
      this.panel   = document.querySelector('[data-kc-fd-panel]');
      this.form    = document.querySelector('[data-kc-fd-form]');
      if (!this.panel) return;

      var self = this;
      document.querySelectorAll('[data-kc-filter-toggle]').forEach(function (b) {
        b.addEventListener('click', function () { self.open(); });
      });
      document.querySelectorAll('[data-kc-fd-close]').forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });
      this.overlay.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.panel.classList.contains('kc-open')) self.close();
      });

      /* Submit -> rebuild URL with active filters, navigate */
      if (this.form) {
        this.form.addEventListener('submit', function (e) {
          e.preventDefault();
          var params = new URLSearchParams();
          /* Preserve current sort if present */
          var sort = new URLSearchParams(window.location.search).get('sort_by');
          if (sort) params.set('sort_by', sort);
          /* Collect checked checkboxes */
          var seen = {};
          self.form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
            params.append(cb.name, cb.value);
            seen[cb.name] = true;
          });
          /* Collect non-empty price ranges */
          self.form.querySelectorAll('input[type="number"]').forEach(function (n) {
            if (n.value && n.value !== '0') params.set(n.name, n.value);
          });
          var url = window.location.pathname;
          var qs = params.toString();
          window.location.href = qs ? (url + '?' + qs) : url;
        });
      }
    },
    open: function () {
      this.overlay.classList.add('kc-open');
      this.overlay.setAttribute('aria-hidden', 'false');
      this.panel.classList.add('kc-open');
      this.panel.setAttribute('aria-hidden', 'false');
      ScrollLock.acquire('filter');
      hapticTap();
    },
    close: function () {
      this.overlay.classList.remove('kc-open');
      this.overlay.setAttribute('aria-hidden', 'true');
      this.panel.classList.remove('kc-open');
      this.panel.setAttribute('aria-hidden', 'true');
      ScrollLock.release('filter');
    }
  };

  /* ══════════════════════════
     SORT SELECT — auto-submit on change
  ══════════════════════════ */
  function initSort() {
    var sel = SCOPE.querySelector('[data-kc-sort]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', sel.value);
      window.location.href = window.location.pathname + '?' + params.toString();
    });
  }

  /* ──────────────────────────
     SIMPLE TAB SECTIONS (kc-use-cases, kc-feature-tabs)
     Wires data-kc-uc-tab/data-kc-uc-panel and the kc-ft-* equivalents.
  ────────────────────────── */
  function initSimpleTabs() {
    var configs = [
      { tab: 'data-kc-uc-tab', panel: 'data-kc-uc-panel', root: '[data-kc-uc]' },
      { tab: 'data-kc-ft-tab', panel: 'data-kc-ft-panel', root: '[data-kc-ft]' }
    ];
    configs.forEach(function (cfg) {
      SCOPE.querySelectorAll(cfg.root).forEach(function (root) {
        var tabs = root.querySelectorAll('[' + cfg.tab + ']');
        var panels = root.querySelectorAll('[' + cfg.panel + ']');
        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            var key = tab.getAttribute(cfg.tab);
            tabs.forEach(function (t) {
              var active = t.getAttribute(cfg.tab) === key;
              t.classList.toggle('kc-active', active);
              t.setAttribute('aria-selected', active ? 'true' : 'false');
            });
            panels.forEach(function (p) {
              p.classList.toggle('kc-active', p.getAttribute(cfg.panel) === key);
            });
          });
        });
      });
    });
  }

  /* ──────────────────────────
     INIT
  ────────────────────────── */
  /* RTL helper — read once at boot so other modules can branch on direction.
     Exposed on window for inline section scripts that need it. */
  const KC_RTL = (document.documentElement.getAttribute('dir') || '').toLowerCase() === 'rtl';
  window.KC_RTL = KC_RTL;

  function initHeroVideo() {
    var modal = document.querySelector('[data-kc-vid-modal]');
    if (!modal) return;
    var player = modal.querySelector('[data-kc-vid-player]');
    function open() {
      modal.classList.add('kc-open');
      modal.setAttribute('aria-hidden', 'false');
      ScrollLock.acquire('video');
      if (player) { try { player.currentTime = 0; player.play(); } catch (e) {} }
    }
    function close() {
      modal.classList.remove('kc-open');
      modal.setAttribute('aria-hidden', 'true');
      ScrollLock.release('video');
      if (player) { try { player.pause(); } catch (e) {} }
    }
    document.querySelectorAll('[data-kc-video-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    modal.querySelectorAll('[data-kc-vid-close]').forEach(function (c) {
      c.addEventListener('click', close);
    });
    // click anywhere outside the video closes it
    modal.addEventListener('click', function (e) {
      if (!e.target.closest('.kc-vid-inner') || e.target.hasAttribute('data-kc-vid-close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && modal.classList.contains('kc-open')) close();
    });
  }

  function initGlobals() {
    /* Bind to document/window or to layout-level snippets that never section-reload. Runs ONCE. */
    Wishlist.init();
    Cart.init();
    Auth.init();
    initAddToCart();
    Lightbox.init();
    hookCartRender();
    FilterDrawer.init();
    AccountDropdown.init();
    MobileMenu.init();
    SearchOverlay.init();
    ExitIntent.init();
    QuickView.init();
    initHeroVideo();
    initOverviewReveal();

    /* Overlays must not survive a bfcache restore / history navigation with the body still locked. */
    function closeAllOverlays() {
      [Cart, Auth, MobileMenu, SearchOverlay, QuickView, Lightbox, FilterDrawer].forEach(function (o) {
        try { if (o && typeof o.close === 'function') o.close(); } catch (e) {}
      });
      ScrollLock.releaseAll();
    }
    window.addEventListener('pageshow', function (e) { if (e.persisted) closeAllOverlays(); });
    window.addEventListener('popstate', function () { closeAllOverlays(); });

    /* Theme Editor: when Shopify re-renders a section, re-run the section-local
       initialisers scoped to that section only (no duplicate global listeners). */
    document.addEventListener('shopify:section:load', function (e) {
      SCOPE = (e && e.target) || document;
      try { initSections(); } finally { SCOPE = document; }
    });
  }

  /* Below-the-fold decorative videos: attach the source only when the element is near the
     viewport (the specs loop is 733 KB and was downloading on every page load, before LCP). */
  function initLazyVideos() {
    var vids = SCOPE.querySelectorAll('video[data-kc-lazy-video][data-src]:not([src])');
    if (!vids.length) return;
    function attach(v) {
      if (v.getAttribute('src')) return;
      v.setAttribute('src', v.dataset.src);
      v.load();
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (!('IntersectionObserver' in window)) { vids.forEach(attach); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { attach(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '400px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  function initSections() {
    /* Section-local: query inside SCOPE, so re-running after a section reload only binds the fresh DOM. */
    hideHCaptchaNotice();
    initCard();
    initCardSwatches();
    initArticleCopyLink();
    initPpV2();
    initRevShowMore();
    initFaq();
    initTrackingFeatures();
    initOptions();
    initQty();
    initProductTabs();
    initSimpleTabs();
    trackProductView();
    renderRecentlyViewed();
    Cookies.init();
    initLiveSales();
    initHelpSearch();
    initOrderTrack();
    initMobileNav();
    initProductPage();
    initGallery();
    initCartPage();
    updateShipbar();
    initHeroParallax();
    initSort();
    BottomBar.init();
    initShare();
    initBundle();
    initLazyVideos();

    /* Haptic taps on key interactions */
    SCOPE.querySelectorAll('[data-kc-cart-toggle], [data-kc-add], .kc-pp-add, .kc-bb-add')
      .forEach(function (el) { if (el.dataset.kcHaptic) return; el.dataset.kcHaptic = '1'; el.addEventListener('click', function () { hapticTap(); }); });
  }

  function start() {
    if (!window.__kcStarted) { window.__kcStarted = true; initGlobals(); }
    initSections();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
